export enum ExpandableComponent {
  ORDER_SUMMARY = 'order-summary',
  VERTICAL_PAYMENT_SCHEDULE = 'vertical-payment-schedule-accordion',
  SHIPPING_ADDRESS_INLINE = 'shipping-address-inline-accordion',
  PAYMENT_METHOD_INLINE = 'payment-method-inline',
  SHIPPING_OPTION = 'shipping-option-accordion',
}
